/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/24/email': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M17.694 21.965c-2.513.961-10.181 2.53-14.34-2.255-4.03-4.637-2.281-11.654.736-15.162 2.726-3.17 8.362-4.636 13.3-2.631a9.071 9.071 0 015.589 9.314c-.173 2.673-1 5.555-3.683 5.764S16.177 14.7 16 13.486a51.1 51.1 0 01.477-6.39c-5.892-1.8-7.972 1.337-8.621 3.258s-.866 4.929 1.56 6.223S15.051 16.2 16 13.486" _fill="none" stroke-miterlimit="10" data-cap="butt" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" _stroke="#272c33"/>'
  }
})
